export default __webpack_public_path__ + "static/media/call_end.5e225e0d.svg";